export const ui = {
    // Toasts das mutações (db/queries/*). Chaves compartilhadas entre domínios
    // de propósito — o texto é curto e repetido (criado/salvo/excluído).
    // Erros de regra de negócio (ExpectedError dos repositories) — viram toast de erro.
    // Variantes sem acento do fonte foram normalizadas aqui.
    errors: {
        writeOffExceedsOutstanding: 'A baixa não pode ser maior que o saldo em aberto.',
        writeOffCategoryMustBeExpense: 'A categoria da baixa precisa ser uma categoria de despesa.',
        excessCategoryMustBeIncome: 'A categoria do excedente precisa ser uma categoria de receita.',
        categoryGone: 'A categoria selecionada não existe mais. Escolha outra categoria e tente novamente.',
        destinationAccountGone: 'A conta de destino selecionada não existe mais. Escolha outra conta e tente novamente.',
        noFreeBalanceToReReserve: 'A conta não tem saldo livre pra re-reservar esse valor. Adicione saldo à conta antes.',
        accountGone: 'A conta selecionada não existe mais. Escolha outra conta e tente novamente.',
        nextInstallmentExceedsTotal: 'A próxima parcela não pode ser maior que o total do contrato.',
        scheduleMustMatchOutstanding: 'A soma do cronograma precisa ser igual ao saldo em aberto.',
        remainingInstallmentsExceedSeries: 'As parcelas restantes informadas são maiores que a série atual do financiamento.',
        scheduleEntryMustBePositive: 'Cada recebimento do cronograma precisa de um valor maior que zero.',
        goalDepositsManagedInGoal: 'Depósitos de meta devem ser gerenciados pela tela da meta.',
        reservaYieldManagedInReserva: 'Esse rendimento é de uma caixinha, e valor, data e conta não mudam por aqui. Para corrigir o valor ou excluir, apague o rendimento no histórico da caixinha: a receita sai junto.',
        // Converter em transferência (ADR 0158).
        convertToTransferUnsupported: 'Só uma despesa ou receita avulsa, numa conta, pode virar transferência.',
        convertToTransferSameAccount: 'Escolha uma conta diferente da atual.',
        convertToTransferCounterpartMismatch: 'O outro lançamento não bate com este (valor, conta ou tipo).',
        chooseWriteOffExpenseCategory: 'Escolha a categoria de despesa da baixa.',
        chooseExcessIncomeCategory: 'Escolha a categoria de receita do excedente.',
        savedAmountWithdrawnLater: 'Esse valor já foi resgatado depois. Ajuste os resgates antes de excluir este Guardar.',
        loanAlreadyClosed: 'Esse valor a receber já está encerrado.',
        financingArchivedNoPaydown: 'Este financiamento está arquivado e não pode receber abatimentos.',
        financingArchivedNoPartialPayment: 'Este contrato está arquivado e não pode receber pagamentos.',
        financingInstallmentGone: 'Esta parcela não existe mais neste contrato.',
        financingCurveRequiredToRecalibrate: 'Só dá para recalibrar um contrato com parcela decrescente (SAC) e taxa informada.',
        financingArchivedNoRecalibrate: 'Não é possível ajustar a projeção de um contrato arquivado.',
        financingInstallmentAlreadyPaid: 'Esta parcela já está paga.',
        partialPaymentAmountInvalid: 'Informe um valor maior que zero para o pagamento parcial.',
        partialPaymentNotPartial: 'O valor cobre a parcela inteira — use o pagamento normal para quitá-la.',
        partialPaymentGone: 'Este pagamento parcial não existe mais.',
        partialPaymentInstallmentSettled: 'A parcela já foi quitada. Desfaça o pagamento dela antes de excluir este parcial.',
        chargesOnPaidInstallment: 'Só dá para lançar encargos em parcela ainda em aberto.',
        chargesNegative: 'Os encargos não podem ser negativos.',
        installmentAmountInvalid: 'O valor final da parcela precisa ser maior que zero.',
        installmentLeavePaidInvoice: 'Parcelas em fatura que já recebeu pagamento não podem sair do cartão. Tente "Esta e futuras" a partir de uma parcela em fatura sem pagamento.',
        installmentRebasePaidInvoice: 'Essa mudança arrastaria parcelas para dentro ou para fora de uma fatura que já recebeu pagamento. Use "Apenas esta", ou "Esta e futuras" a partir de uma parcela em fatura sem pagamento.',
        financingArchivedNoUndo: 'Este financiamento está arquivado. Desfazer abatimentos traria parcelas pendentes de volta ao fluxo.',
        writeOffDateRequired: 'Informe a data da baixa.',
        loanDateRequired: 'Informe a data.',
        nextDueDateRequiredRegen: 'Informe a data do próximo vencimento para regenerar as parcelas.',
        nextDueDateRequired: 'Informe a data do próximo vencimento.',
        paymentDateRequired: 'Informe a data do recebimento.',
        nextInstallmentRequired: 'Informe a próxima parcela que será acompanhada.',
        personNameRequired: 'Informe o nome da pessoa.',
        contractNameRequired: 'Informe o nome do contrato.',
        paydownInstallmentAmountInvalid: 'Informe um valor de parcela válido para o abatimento.',
        financingMonthlyAmountInvalid: 'Informe um valor mensal válido para o financiamento.',
        writeOffAmountInvalid: 'Informe um valor válido para a baixa.',
        loanAmountInvalid: 'Informe um valor válido.',
        paymentAmountInvalid: 'Informe um valor válido para o recebimento.',
        personNameTaken: 'Já existe uma pessoa com esse nome.',
        subcategoryNameTaken: 'Já existe uma subcategoria com esse nome nesta categoria.',
        tagNameTaken: 'Já existe uma tag com esse nome.',
        paydownEntriesManagedInFinancing: 'Lançamentos de abatimento devem ser gerenciados pela tela do financiamento.',
        loanEntriesManagedInLoans: 'Esse lançamento é gerenciado pela tela Quem me deve.',
        financingEntriesManagedInFinancing: 'Lançamentos de financiamento devem ser gerenciados pela tela do financiamento.',
        financingLoanEntriesManaged: 'Lançamentos de financiamento e empréstimo devem ser gerenciados pelas telas deles.',
        invoicePaymentManagedInInvoice: 'Pagamento de fatura se desfaz na tela da fatura, pela lixeira do pagamento.',
        noPendingInstallmentsToPayDown: 'Não há parcelas pendentes para abater neste financiamento.',
        cannotDeleteSingleFutureOccurrence: 'Não é possível excluir apenas esta ocorrência futura.',
        paydownWouldRemoveDueInstallments: 'O abatimento informado tentaria remover parcelas já vencidas ou em aberto.',
        advanceExceedsPendingTotal: 'O valor pago é maior que o total das parcelas pendentes. Para quitar o contrato, pague as parcelas.',
        cardGone: 'O cartão selecionado não existe mais. Escolha outro cartão e tente novamente.',
        tagNameEmpty: 'O nome da tag não pode ficar vazio.',
        totalInstallmentsBelowNext: 'O total de parcelas não pode ser menor que o número da próxima parcela.',
        totalInstallmentsLockedAfterFirst: 'O total de parcelas só pode ser alterado antes do primeiro pagamento ou abatimento.',
        installmentPlanNotConvertible: 'Parcelamentos não podem ser convertidos em recorrência',
        financingInstallmentsManaged: 'Parcelas de financiamento devem ser gerenciadas pela tela do financiamento.',
        personNotFound: 'Pessoa não encontrada. Selecione ou crie a pessoa novamente.',
        renegotiationsAreHistory: 'Renegociações de data são histórico e não podem ser desfeitas.',
        financingCategoryRequired: 'Selecione a categoria do financiamento.',
        sourceAccountRequired: 'Selecione a conta de onde o dinheiro saiu.',
        financingPaymentAccountRequired: 'Selecione a conta de pagamento do financiamento.',
        receivingAccountRequired: 'Selecione a conta que recebeu o dinheiro.',
        existingReceiptOnlyOnExistingLoan: 'Recebimento antes do app só existe quando o dinheiro não saiu da sua conta.',
        existingReceiptExceedsOutstanding: 'Recebimento antes do app não pode passar do saldo em aberto — o que excede é receita e precisa de conta.',
        categoryRequired: 'Selecione ao menos uma categoria.',
        loanLockedAfterFirstEntry: 'Valor, data e conta só podem ser alterados antes do primeiro recebimento ou baixa.',
        categoryDeleteOnlyArchivedLeft: 'A única outra categoria do mesmo tipo está arquivada. Reative-a (ou crie outra ativa) antes de apagar esta.',
        categoryDeleteNeedsAnother: 'Crie outra categoria do mesmo tipo antes de apagar esta.',
    },
    toasts: {
        // Título do toast de erro das mutações (app/_layout.tsx). Regra de negócio (ExpectedError)
        // não é falha: a mensagem explica o que fazer, e "Algo deu errado" assustava à toa.
        mutationFailed: 'Algo deu errado',
        mutationRefused: 'Não deu para concluir',
        tryAgain: 'Tente novamente.',
        convertedToTransfer: 'Virou transferência',
        accountCreated: 'Conta criada',
        accountSaved: 'Conta salva',
        accountDeleted: 'Conta excluída',
        accountReactivated: 'Conta reativada',
        cardCreated: 'Cartão criado',
        cardSaved: 'Cartão salvo',
        cardDeleted: 'Cartão excluído',
        cardArchived: 'Cartão arquivado',
        cardReactivated: 'Cartão reativado',
        categoryCreated: 'Categoria criada',
        categorySaved: 'Categoria salva',
        categoryDeleted: 'Categoria apagada',
        categoryArchived: 'Categoria arquivada',
        categoryReactivated: 'Categoria reativada',
        categoriesUpdated: 'Categorias atualizadas',
        categoriesMerged: 'Categorias mescladas',
        categoryDeleteFailed: 'Não foi possível apagar a categoria',
        subcategoryCreated: 'Subcategoria criada',
        subcategorySaved: 'Subcategoria salva',
        subcategoryRemoved: 'Subcategoria removida',
        transactionSaved: 'Transação salva',
        transactionDeleted: 'Transação excluída',
        // Ação do toast de exclusão: é ela que permite excluir DIRETO, sem o
        // diálogo "Tem certeza?" numa ação que sempre deu pra desfazer.
        undoAction: 'Desfazer',
        transactionRestored: 'Transação restaurada',
        transactionsDeleted: 'Transações excluídas',
        transactionConfirmed: 'Transação concluída',
        markedPending: 'Marcada como pendente',
        transferRecorded: 'Transferência registrada',
        installmentPlanCreated: 'Parcelamento criado',
        installmentPlanDeleted: 'Parcelamento excluído',
        budgetCreated: 'Orçamento criado',
        budgetSaved: 'Orçamento salvo',
        budgetDeleted: 'Orçamento excluído',
        goalCreated: 'Meta criada',
        goalSaved: 'Meta salva',
        goalDeleted: 'Meta excluída',
        goalCompleted: 'Meta concluída',
        goalReopened: 'Meta reaberta',
        pocketCreated: 'Caixinha criada',
        pocketSaved: 'Caixinha salva',
        pocketDeleted: 'Caixinha excluída',
        pocketArchived: 'Caixinha arquivada',
        pocketReactivated: 'Caixinha reativada',
        pocketReactivatedZeroed: 'Caixinha reativada zerada',
        pocketEmpty: 'Caixinha sem saldo',
        savedToPocket: 'Guardado na caixinha',
        withdrawnFromPocket: 'Resgatado da caixinha',
        noFreeBalanceToSave: 'Sem saldo livre pra guardar',
        depositRecorded: 'Depósito registrado',
        depositRemoved: 'Depósito removido',
        yieldRecorded: 'Rendimento registrado',
        movementDeleted: 'Movimento excluído',
        balanceAdjusted: 'Saldo ajustado',
        recurringCreated: 'Recorrência criada',
        recurringSaved: 'Recorrência salva',
        recurringDeleted: 'Recorrência excluída',
        recurringHidden: 'Recorrência ocultada',
        recurringUnhidden: 'Recorrência reexibida',
        recurringLinked: 'Recorrência vinculada',
        occurrenceRecorded: 'Ocorrência registrada',
        reminderOn: 'Aviso ativado',
        reminderOff: 'Aviso desativado',
        financingCreated: 'Financiamento criado',
        financingArchived: 'Financiamento arquivado',
        financingDeleted: 'Financiamento excluído',
        // O mesmo contrato vale para os dois tipos (ADR 0055); só o rótulo muda.
        loanContractCreated: 'Empréstimo criado',
        loanContractArchived: 'Empréstimo arquivado',
        loanContractDeleted: 'Empréstimo excluído',
        contractUpdated: 'Contrato atualizado',
        paydownRecorded: 'Abatimento registrado',
        partialPaymentRecorded: 'Pagamento parcial registrado',
        partialPaymentDeleted: 'Pagamento parcial excluído',
        installmentChargesSaved: 'Encargos atualizados',
        financingCurveRecalibrated: 'Projeção ajustada ao valor do boleto.',
        paydownDeleted: 'Abatimento excluído',
        interestFeesRecorded: 'Juros e multa lançados',
        adjustmentSaved: 'Ajuste manual salvo',
        adjustmentRemoved: 'Ajuste manual removido',
        adjustmentUpdated: 'Ajuste atualizado',
        statusUpdated: 'Status atualizado',
        paymentRecorded: 'Pagamento registrado',
        paymentRecordedInvoiceStillOpen: 'Pagamento registrado. A fatura continua aberta.',
        paymentRemoved: 'Pagamento removido',
        creditRecorded: 'Crédito lançado',
        creditRolledToNext: 'Crédito levado para a próxima fatura',
        balanceRolledToNext: 'Saldo levado para a próxima fatura',
        adjustmentOnInvoice: 'Ajuste lançado na fatura',
        loanRecorded: 'Valor a receber registrado',
        loanUpdated: 'Valor a receber atualizado',
        loanDeleted: 'Valor a receber excluído',
        loanPaymentRecorded: 'Recebimento registrado',
        writeOffRecorded: 'Baixa registrada',
        scheduleUpdated: 'Cronograma atualizado',
        entryUndone: 'Registro desfeito',
        personRenamed: 'Pessoa renomeada',
        tagCreated: 'Tag criada',
        tagUpdated: 'Tag atualizada',
        tagAdded: 'Tag adicionada',
        tagsUpdated: 'Tags atualizadas',
        tagDeleted: 'Tag excluída',
        ruleCreated: 'Regra criada',
        ruleUpdated: 'Regra atualizada',
        ruleDeleted: 'Regra excluída',
        notificationDismissed: 'Notificação descartada',
        notificationsDismissed: 'Notificações descartadas',
        notificationRestored: 'Notificação de volta às pendentes',
        notificationsRestored: 'Notificações de volta às pendentes',
        nothingToUpdate: 'Nada para atualizar',
        amountMustBePositive: 'Valor deve ser maior que 0',
        undoFailed: 'Não foi possível desfazer',
        deleteFailed: 'Não foi possível excluir',
        saveFailed: 'Não foi possível salvar',
        recordFailed: 'Não foi possível registrar',
        renameFailed: 'Não foi possível renomear',
        reactivateFailed: 'Não deu pra reativar',
        cannotDelete: 'Não dá pra excluir',
        rulesReapplied_one: '{{count}} transação reaplicada',
        rulesReapplied_other: '{{count}} transações reaplicadas',
        rulesFilled_one: '{{count}} transação preenchida',
        rulesFilled_other: '{{count}} transações preenchidas',
    },
    actionSheet: {
        cancelLabel: 'Cancelar',
    },
    confirmDialog: {
        confirmLabel: 'Confirmar',
        cancelLabel: 'Cancelar',
    },
    infoDialog: {
        okLabel: 'OK',
    },
    dateField: {
        placeholder: 'Selecionar data',
    },
    dateTimePicker: {
        doneButton: 'Concluído',
        cancelButton: 'Cancelar',
        okButton: 'OK',
    },
    headerBackButton: {
        backAccessibilityLabel: 'Voltar',
    },
    headerSearchButton: {
        openAccessibilityLabel: 'Buscar nesta lista',
        closeAccessibilityLabel: 'Fechar busca',
    },
    iconGroups: {
        money: 'Dinheiro',
        homeBills: 'Casa & Contas',
        foodDrink: 'Comida & Bebida',
        transport: 'Transporte',
        shopping: 'Compras',
        healthWellness: 'Saúde & Bem-estar',
        educationWork: 'Educação & Trabalho',
        leisureHobbies: 'Lazer & Hobbies',
        aiStreaming: 'IA & Streaming',
        travelNature: 'Viagem & Natureza',
        familyPets: 'Família & Pets',
        general: 'Geral',
    },
    iconPicker: {
        searchPlaceholder: 'Buscar ícone...',
        emptyResults: 'Nenhum ícone encontrado',
    },
    lockScreen: {
        pinTitle: 'Digite seu PIN',
        biometricSubtitle: 'Use {{biometric}} ou digite seu PIN',
        defaultSubtitle: 'Para acessar o Kontto',
        pinIncorrect: 'PIN incorreto',
        pinValidationError: 'Falha ao validar o PIN',
    },
    pinInput: {
        verifying: 'Verificando...',
    },
    searchBar: {
        placeholder: 'Buscar...',
    },
    swipeableRow: {
        editAction: 'Editar',
        deleteAction: 'Excluir',
        payAction: 'Pagar',
        receiveAction: 'Receber',
        settleAction: 'Efetivar',
        pendingAction: 'Pendente',
    },
    tabBar: {
        addAccessibilityLabel: 'Adicionar',
    },
    // Nome do registro recriado pelo reparo de referência pendurada (ADR 0165): a conta/o
    // cartão já estava excluído no aparelho de origem e voltou sem o nome original.
    deletedRecords: {
        account: 'Conta excluída',
        card: 'Cartão excluído',
    },
};
